import { Sentry } from "../sentryInstrumentReact";
import React, { createContext, useEffect, useContext, useState} from 'react';

const CartContext = createContext();

export function useCart() {
  return useContext(CartContext);
}

export function CartProvider({children}) {
  const [cart, setCart] = useState({
    items: [],
  });
  const [cartSubtotal, setCartSubtotal] = useState(0);
  const [cartSubtotalWithDiscount, setCartSubtotalWithDiscount] = useState(0);
  const [cartTotal, setCartTotal] = useState(0);

  const [rendering, setRendering] = useState(true);
  const [cartTax, setCartTax] = useState(0);
  const [shipping, setShipping] = useState({
    cost: 0, 
    rateId: "",
  });
  const [donation, setDonation] = useState(0);
  const [discountCode, setDiscountCode] = useState('');
  const [discountLocked, setDiscountLocked] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [checkoutSubmitting, setCheckoutSubmitting] = useState(false);
  const [shippingSameAsBilling, setShippingSameAsBilling] = useState(true);
  const [shippingRequired, setShippingRequired] = useState(true);
  const [fetchingShippingCost, setFetchingShippingCost] = useState(false); // only used to animate loading
  const [fetchingTaxCost, setFetchingTaxCost] = useState(false); // only used to animate loading
  const [checkoutErrors, setCheckoutErrors] = useState({
    // exp_month: ["this is a thing"],
    // exp_year: ["year is incorrect"],
    // region: ["please select a billing region"],
    // shipping_region: ["please select a shipping region"],
    // shipping_country: ["please select a shipping country"],
    // country: ["please select a billing country"],
    // shipping_method: ["please choose a proper shipping method"],
  });
  const [checkoutFormData, setCheckoutFormData] = useState({
    billing: {
      firstName: '',
      lastName: '',
      organization: '',
      email: '',
      phone: '',
      street1: '',
      street2: '',
      city: '',
      region: '',
      postalCode: '',
      country: '',
      addressComplete: false,
    },
    shipping: {
      firstName: '',
      lastName: '',
      organization: '',
      street1: '',
      street2: '',
      city: '',
      region: '',
      postalCode: '',
      country: '',
      addressComplete: false,
    },
  });


  // get products in cart
  useEffect(() => {
    async function fetchCartData() {
      try {
        const response = await fetch("/store/_api/cart/");
        const cartObject = await response.json();
        setCart(cartObject);
        setDonation(cartObject.donation ? parseFloat(cartObject.donation).toFixed(2) : '');

        setCartSubtotal(parseFloat(cartObject.subtotal).toFixed(2));
        setCartSubtotalWithDiscount(parseFloat(cartObject.discounted_subtotal).toFixed(2));
        setShippingRequired(cartObject.shipping_required);
        const cartTotalWithDonation = parseFloat(cartObject.discounted_subtotal) + (parseFloat(cartObject.donation || 0));
        setCartTotal(cartTotalWithDonation.toFixed(2));
        
        setRendering(false);
        setDiscountAmount(parseFloat(cartObject.discount_amount).toFixed(2));
        setDiscountCode(cartObject.discount_code);
        if(cartObject.discount_code !== '') {
          setDiscountLocked(true);
        }
      } catch(error) {
        Sentry.captureException?.(error, {stage: "get cart context data"});
      }
    }
    fetchCartData();

  }, []);

  return (
    <CartContext.Provider value={{ 
      cart, 
      setCart, 
      cartTotal, 
      setCartTotal, 
      cartSubtotal, 
      setCartSubtotal,
      cartSubtotalWithDiscount, 
      setCartSubtotalWithDiscount,
      rendering,
      setRendering, 
      cartTax,
      setCartTax,
      shipping,
      setShipping,
      donation,
      setDonation,
      discountCode,
      setDiscountCode,
      discountLocked,
      setDiscountLocked,
      discountAmount,
      setDiscountAmount,
      checkoutSubmitting,
      setCheckoutSubmitting,
      shippingSameAsBilling, 
      setShippingSameAsBilling,
      shippingRequired,
      setShippingRequired,
      checkoutErrors,
      setCheckoutErrors,
      checkoutFormData,
      setCheckoutFormData,
      fetchingShippingCost,
      setFetchingShippingCost,
      fetchingTaxCost,
      setFetchingTaxCost
    }}>
      {children}
    </CartContext.Provider>
  )
}
